import { render, staticRenderFns } from "./ProvidersList.vue?vue&type=template&id=5501dda2&scoped=true&"
import script from "./ProvidersList.vue?vue&type=script&lang=js&"
export * from "./ProvidersList.vue?vue&type=script&lang=js&"
import style0 from "./ProvidersList.vue?vue&type=style&index=0&id=5501dda2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5501dda2",
  null
  
)

component.options.__file = "ProvidersList.vue"
export default component.exports